import phoneValidation from './videoClasses.es';

export default {
  ...phoneValidation,
};
